<template>
    <div  class="background">
     <div>
      <AppBar/>
     </div>
    <!-- timer for bookings -->
     <v-snackbar v-model="snackbar" :color="color" top :timeout="5000">
          <v-row justify="space-between">
            {{ text }}
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
     </v-snackbar>
    <overlay v-if="($store.state.flightsTimeOut && tab === 0) || ($store.state.carsTimeOut && tab === 1) || ($store.state.hotelTimeOut && tab === 2)"/>
      <div class="center-wrapper">
        <div>
          <v-card
            class="mx-auto text-center py-2 indigo--text font-weight-bold"
            elevation="0"
            style="width: 35%;"
          >
            <div class="d-flex align-center justify-center">
              <img src="../assets/images/TK.png" width="50" />
              ATSFares
            </div>
          </v-card>
          <v-card class="mx-7 rounded-xl" elevation="0">
            <flightSearch/>
          </v-card>
        </div>
      </div>

    <!-- <v-card elevation="0" class="bg">
      <v-tabs
      v-model="tab"
      background-color="transparent"
      color="indigo"
      class="tabs"
      v-show="false"
      >
        <v-tab
          v-for="item in items"
          :key="item.title"
        >
          <v-icon left>{{item.icon}}</v-icon>{{ item.title }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" elevation="1">
        <v-tab-item class="elevation-4 ma-5 rounded-xl d-flex align-center mt-15" style="margin-top: 130px !important;">
          <div>TK</div>
          <v-container>
            <flightSearch @scrollNow="scrollNow"/>
          </v-container>
        </v-tab-item>
         <v-tab-item>
          <hotelSearch @scrollNow="scrollNow"/>
        </v-tab-item>
        <v-tab-item>
          <carSearch @scrollNow="scrollNow"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card> -->

    <!-- <flightResults style="z-index: 2 !important;" v-if="$store.state.showFlightResults && tab === 0" /> -->
    <!-- <hotelsResults style="transform: translateY(-150px);" v-if="$store.state.showHotelResults && tab === 1"/> -->
    <!-- <oneHotel style="transform: translateY(-150px);" v-if="$store.state.showOneHotel && tab === 1"/> -->
    <!-- <carsResults style="transform: translateY(-150px);" v-if="$store.state.showCarResults && tab === 2"/> -->
    <!-- <v-dialog persistent v-model="$store.state.showFlightBook" scrollable width="100%" style="position: relative;">
      <v-card class="pb-0" color="#f8f8f8">
      <v-card-title class="mb-5">
      <v-btn
      @click="$store.dispatch('setShowFlightBook', false)"
      icon
      absolute
      top
      left
      style="font-size: 40px; color: navy;"
      >
        &times;
      </v-btn>
      </v-card-title>
      <v-card-text class="mb-5">
      <book v-if="$store.state.showFlightBook"/>
      </v-card-text>
      </v-card>
    </v-dialog> -->
</div>
</template>
<script>
import flightSearch from '../views/flights.vue'
import overlay from '../components/overlay.vue'
// import flightResults from '../views/flightResults.vue'
import { mapState } from 'vuex'
import { headersAuth } from '../links'
import AppBar from '../components/AppBar.vue'
export default {
  name: 'App',
  components: {
    flightSearch,
    overlay,
    AppBar
  },
  data () {
    return {
      tab: null,
      snackbar: false,
      color: null,
      text: null,
      items: [
        { title: 'Flights', icon: 'mdi-airplane' }
        // { title: 'Hotels', icon: 'mdi-domain' },
        // { title: 'Cars', icon: 'mdi-car' }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    scrollNow () {
      // const height = window.innerHeight
      // this.$vuetify.goTo(height, { duration: 1000 })
      this.$router.push('/flightResult')
    },
    logout () {
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      const body = ''
      this.$http.post('https://www.atnbookingengine.com/api/user/logout', body, header).then(response => {
        console.log(response.data)
        if (response.data.status) {
          this.text = response.data.message
          this.color = 'success'
          this.snackbar = true
          this.$store.commit('setUser', null)
          this.$store.commit('setUserId', null)
          this.$store.commit('setUserData', null)
          this.$store.commit('setEmail', null)
          this.$router.push('/login')
        } else {
          this.text = response.data.message
          this.color = 'error'
          this.snackbar = true
        }
      }).catch(err => {
        console.error(err)
        this.text = err.body.message
        this.color = 'error'
        this.snackbar = true
      })
    }
  },
  created () {
    // this.$store.state.flightDates.departureDates = [null, null, null]
    // this.$store.state.flightDates.arrivalDate = null
    this.$store.dispatch('setPassengersAdults', 1)
    this.$store.dispatch('setPassengersChildren', 0)
    this.$store.dispatch('setPassengersInfants', 0)
    this.$store.dispatch('setPassengersClass', 'Y')
    this.$store.dispatch('setShowFlightResults', false)
    this.$store.dispatch('setShowFlightBook', false)
    this.$store.dispatch('removetFlightResults')
    this.$store.dispatch('clearFlightsSearchTimeoutFunction')
    this.$store.dispatch('clearFlightsTimeoutFunction')
    this.$store.dispatch('setStreet', '')
    this.$store.dispatch('setWrittenCity', '')
    this.$store.dispatch('setZipCode', '')
    this.$store.dispatch('setWrittenCountry', '')
    this.$store.dispatch('setWrittenState', '')
    this.$store.dispatch('setFlightsTimeOut', false)
    this.$store.commit('setPaymentTab', 'reserve')
    this.$store.commit('setPaymentMethod', 'cash')
  }
}
</script>

<style>
  input {
    outline: none;
  }
  .tabs {
    margin-top: 20px;
    transform: translateY(-5px);
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: rgb(161, 161, 161) !important;
  }
  .bg {
    background-color: transparent !important;
    /* min-height: 500px; */
  }
 .v-window-item.v-window-item--active {
    background-color: #ffffff;
   }
  .v-window.v-item-group.theme--light.v-tabs-items {
    background-color: transparent;
  }
  .daterangepicker td.in-range {
    background-color: #93deff;
  }
  .daterangepicker td.active {
    background-color: #0086bf;
  }
  .dots-text:hover {
    background-color: rgb(230, 230, 230);
    color: blue;
  }
  @media screen and (max-width:945px) {
    .v-window__container {
      min-height:100vh;
    }
  }
  .background{
    background: linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.2)),
    url('../assets/images/bg.jpg');
    background-position: center;
    background-size: cover;
    min-height: 100vh;
  }
  .center-wrapper {
  min-height: calc(100vh - 90px);          /* full screen height */
  display: flex;
  align-items: center;        /* vertical center */
  justify-content: center;    /* horizontal center */
}

</style>
